import React, {useState} from 'react';
import {DateTime} from 'luxon';

export default function EventDateControl({value, onChange, disabled = false, label = 'Event date'}) {
  const [editing, setEditing] = useState(false);
  const date = DateTime.fromISO(value || '');
  const change = event => {if (event.target.value && event.target.value !== value) onChange(event.target.value);};
  return <div className="event-date-display event-date-control">
    <button type="button" disabled={disabled} aria-expanded={editing} onClick={() => setEditing(open => !open)}
      title="Change event date">{date.isValid ? date.setLocale('en').toFormat('dd/LLL/yyyy') : 'Choose date'}</button>
    <input type="date" aria-label={label} required hidden={!editing} disabled={disabled} value={value || ''}
      onChange={change} onInput={change}/>
  </div>;
}
